import React from 'react'
import ServiceCard from './ServiceCard'
import { Col } from 'reactstrap'
import weatherImg from '../assets/images/weather.png'
import guideImg from '../assets/images/guide.png'
import customizationImg from '../assets/images/customization.png'

const servicesData = [
    {
        imgUrl: weatherImg,
        title: 'Mission',
        desc: 'Our mission is to deliver extraordinary travel experiences that connect our clients with Kenyas natural beauty, wildlife, and cultural heritage. We strive to provide personalized services, ensuring every trip is seamless, safe, and enriching.',
    },
    {
        imgUrl: guideImg,
        title: 'Vision',
        desc: 'To be the leading provider of exceptional safaris and tours in Kenya, renowned for offering unique, memorable experiences that inspire travelers to explore and appreciate the diverse wonders of our beautiful country.',
    },
    {
        imgUrl: customizationImg,
        title: 'Our Values',
        desc: 'We are committed to delivering personalized services that meet the unique needs of each traveler. We are dedicated to promoting eco-friendly tourism practices that protect Kenya’s natural environment',
    },
]


const AboutServiceList = () => {
  return (
    <>
      {
        servicesData.map((item, index)=> (< Col lg='3' key={index}>
            <ServiceCard item={item} />
            </Col>
            ))}
    </>
  )
}

export default AboutServiceList
